import { put, select, takeLatest } from "redux-saga/effects"
import { Types as LoaderTypes } from "model/graphql"
import { Creators as analyzeConcentrationCreators } from "modules/analyze-concentration-details/model"
import { chain, get } from "lodash"

function* handleLoadSuccess({ resource, data }) {
  if (resource === "groupedConcentrationContributors") {
    const { selectedGroup } = yield select(state => ({
      selectedGroup: get(state, "modules.analyzeConcentrationDetails.selectedGroup"),
    }))

    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.composition.0.compositionBy")
        .some(item => item.id === selectedGroup.id)
        .value()

      if (!selectedGroupExists) {
        yield put(analyzeConcentrationCreators.hideGroup())
      }
    }
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
